<template>
  <div id="restaurant-menu-calendar">
    <div id="calendar" class="restaurant-calendar"></div>
  </div>
</template>
<script>
  /* global $ */
  import axios from 'axios';
  import moment from 'moment';

  const MonChange = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };

  export default {
    name: 'restaurant-menu-calendar',
    props: ['org'],
    data() {
      return {
        MonChange,
        events: [],
        getEvents: [],
        getMonth: [],
        getDates: [],
      };
    },
    watch: {
      events() {
        this.eventSetting();
        this.changeCalendar();
      },
    },
    methods: {
      changeCalendar() {
        const self = this;
        self.cal = $('#calendar');
        const events = this.getEvents;
        self.cal.fullCalendar('removeEvents');
        self.cal.fullCalendar('addEventSource', events);
      },
      drawCalendar() {
        const self = this;
        self.cal = $('#calendar');
        const args = {
          locale: 'ko',
          header: {
            left: '',
            center: 'title',
            right: 'prev, next',
          },
          height: 'auto',
          allDaySlot: false,
          slotEventOverlap: false,
          events: self.getEvents,
        };

        if (self.editable) {
          args.editable = true;
          args.eventResize = (event) => {
            self.$emit('event::resized', event);
          };

          args.eventDrop = (event) => {
            self.$emit('event::dropped', event);
          };
        }

        if (self.droppable) {
          args.droppable = true;
          args.eventReceive = (event) => {
            self.$emit('event::received', event);
          };
        }

        self.cal.fullCalendar(args);

        $('body').on('click', 'button.fc-prev-button', () => {
          const date = new Date(self.cal.fullCalendar('getDate'));
          const year = date.getFullYear().toString();
          let thisMonth = '';
          let month = '';
          const IECheck = this.globalGetInternetExplorerVersion();
          if (IECheck <= 10) {
            month = date.getMonth() + 2 < 10 ? `0${date.getMonth() + 2}` : date.getMonth() + 2;
          } else {
            month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
          }
          thisMonth = `${year.substr(2, 2)}${month}`;
          if (this.getMonth.indexOf(thisMonth) === -1) {
            this.getEventData(thisMonth);
            this.getMonth.push(thisMonth);
          }
        });

        $('body').on('click', 'button.fc-next-button', () => {
          const date = new Date(self.cal.fullCalendar('getDate'));
          const year = date.getFullYear().toString();
          let thisMonth = '';
          let month = '';
          const IECheck = this.globalGetInternetExplorerVersion();
          if (IECheck <= 10) {
            month = date.getMonth() + 2 < 10 ? `0${date.getMonth() + 2}` : date.getMonth() + 2;
          } else {
            month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
          }

          thisMonth = `${year.substr(2, 2)}${month}`;
          if (this.getMonth.indexOf(thisMonth) === -1) {
            this.getEventData(thisMonth);
            this.getMonth.push(thisMonth);
          }
        });
      },
      getEventData(yearMonth) {
        axios.get(`/api/restaurant-menus?org=${this.org}&month=${yearMonth}`).then((response) => {
          this.events = response.data.menus || [];
        }).catch((error) => {
          alert(error.data.msg);
        });
      },
      eventSetting() {
        const events = this.events;
        events.forEach((val) => {
          if (this.getDates.indexOf(Number(val.date)) === -1) {
            const dateString = val.date.toString();
            const dateYear = dateString.substr(0, 2);
            const dateMonth = dateString.substr(2, 2);
            const dateDay = dateString.substr(4);
            const startDate = `20${dateYear}-${dateMonth}-${dateDay} 00:00:00`;
            const endDate = `20${dateYear}-${dateMonth}-${dateDay} 23:59:59`;
            this.getEvents.push({
              id: Number(val.date),
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              textColor: '#2c2c2c',
              allDay: true,
              start: startDate,
              end: endDate,
              title: val.menu,
            });
            this.getDates.push(Number(val.date));
          }
        });
      },
    },
    mounted() {
      const getMoment = moment().locale('ko');
      const today = getMoment.format('YYMM');
      this.getMonth.push(today);
      this.getEventData(today);
      this.drawCalendar();
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// RestaurantCalendar.vue?669396cd